import { render, staticRenderFns } from "./MesaNewSeparar.vue?vue&type=template&id=7669bb36&scoped=true"
import script from "./MesaNewSeparar.vue?vue&type=script&lang=js"
export * from "./MesaNewSeparar.vue?vue&type=script&lang=js"
import style0 from "./MesaNewSeparar.vue?vue&type=style&index=0&id=7669bb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669bb36",
  null
  
)

export default component.exports